// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"1ccd0658","990":"573f89ba"}[chunkId] + ".chunk.js";
};